import { _ } from '../../vendor';

import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection'

/**
 * Proxy-less collection & wrapper around main used filter- and sort-methods
 * 
 * @see API-approach https://github.com/jmorrell/backbone.obscura#api
 */
export default InboomaBaseAsyncCollection.extend({

    _filterParams : {},

    _refetchCollection (keepCollectionData,callback) {
        
        const that = this;

        if (typeof this._adjustCollectionUrl === 'function') {
            // Static callback to alter `this.url` depending on active filters
            this._adjustCollectionUrl();
        }

        this.fetch({ add:false, merge:false, remove:false })
            .then((data) => {
                // Reset whole collection with new data, trigger app-specific events
                that._setCollectionData(data.response, false, { add:true, merge:true, remove: keepCollectionData ? false : true });
                if (typeof callback === "function") callback(true);
            })
            .catch((data) => {
                // @todo
                if (typeof callback === "function") callback(false);
            });
    },

    // @todo Override fetch
    //
    // fetch () { 
    //     this._pagination.current_page = 0;
    //     this._refetchrefetchColCollection();
    //     -> Eventually, call Backbone.Collection.fetch.bind(this)???
    //  }

    addFilter (key, value, refetch = true) {

        this._filterParams[key] = value;
        this._pagination.current_page = 0;

        if (refetch) {
            this._refetchCollection();
        }

        this.trigger('select:filter', key, value);

        return this;
    },

    removeFilter (key, refetch = true) {

        if (typeof this._filterParams[key] !== 'undefined') {

            delete this._filterParams[key];
            this._pagination.current_page = 0;

            if (refetch) {
                this._refetchCollection();
            }

            this.trigger('unselect:filter', key);
        }

        return this;
    },

    resetFilters (refetch = true) {

        this._filterParams = {};
        this._pagination.current_page = 0;

        if (refetch) {
            this._refetchCollection();
        }

        this.trigger('reset:filter');

        return this;
    },

    /**
     * @method resetFiltersKeepQuery
     * Unsets all non-"query" filters 
     */
    resetFiltersKeepQuery (refetch = true) {

        const that = this;

        _.each(this._filterParams, (elem, key) => {
            if (key !== 'q') {
                delete that._filterParams[key];
            }
        });

        this._pagination.current_page = 0;

        if (refetch) {
            this._refetchCollection();
        }

        this.trigger('reset:filter');

        return this;
    },

    /**
     * @public
     * @method getFilters
     * @return {array} Active filters as array
     */
    getFilters () {
        
        let arr = [];

        _.each(this._filterParams, (elem, key) => {
            arr.push(key);
        });

        return arr;
    },

    /**
     * @public
     * @method getFiltersWithValue
     * @return {object} Contents of this._filterParams
     */
    getFiltersWithValue () {
        return { ...this._filterParams };
    },

    getFilterCount () {
        return _.size(this._filterParams);
    },

    setSort (comparator, direction, refetch = true) {

        this._pagination.sort = comparator;
        this._pagination.sortDirection = direction;
        this._pagination.current_page = 0;

        if (refetch) {
            this._refetchCollection();
        }

        return this;
    },

    deleteSort () {

        this._pagination.sort = '';
        this._pagination.sortDirection = '';
        this._pagination.current_page = 0;

        this._refetchCollection();

        return this;
    },

    filterByQuery (val) {

        if (val.length >= 2) {
            return this.addFilter('q', val);
        } else {
            return this.removeFilter('q');
        }
    },

});
